var getNative = require('./_getNative');

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;



//////////////////
// WEBPACK FOOTER
// ./~/victory-brush-line/~/lodash/_nativeCreate.js
// module id = ./node_modules/victory-brush-line/node_modules/lodash/_nativeCreate.js
// module chunks = 1